.bc{flex-shrink:0;}